// -----------------------------------------------------------------------------
export class PromiseAwaiter {

  // ---------------------------------------------------------------------------
  // Settle all promises and return their resolved values positionally; a
  // rejected promise becomes null (callers null-check per slot).
  public static async wait(promises: Promise<any>[]): Promise<any[]> {
    const rawResponse = await Promise.allSettled(promises);
    return rawResponse.map(res =>
      res.status === 'fulfilled' ? res.value : null,
    );
  }
}